import { render, staticRenderFns } from "./StartDay.vue?vue&type=template&id=d9e74540&"
import script from "./StartDay.vue?vue&type=script&lang=js&"
export * from "./StartDay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports